export default __webpack_public_path__ + "static/media/842.dadc9db8.gif";